export default {"src":"/_next/static/media/trekking.483e69ee.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};